import BookingStatus from "@/models/Bookings/BookingStatus";

export default class BookingSearchRequest {
    startAtFrom: string;
    companyId: string;
    locationId: string;
    branchId: string;
    status: BookingStatus
}